import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import store from '../../Redux';
import { doPost, doLoad, doPut, select, doDelete } from '../../Redux/Actions'

import { TextFieldHelper, SelectFieldWrapper } from '../../Components/Fields';

import Button from '@material-ui/core/Button';
import Dialog from '../../Components/Dialog';
import Table from '../../Components/Table';
import Loader from '../../Components/Loader';
import Grid from '@material-ui/core/Grid';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import AddIcon from '@material-ui/icons/Add';

const columns = ["Gruppe", "Anrede / Firmenname", "Plz", "Ort", "Adresse"];
const options = {}

const styles = theme => ({
    fab: {
       position: 'absolute',
       bottom: theme.spacing.unit * 2,
       right: theme.spacing.unit * 2,
    },
})

var KontaktDialog = ({handleChange, data}) => {
    return (
        <div>
            <Grid container spacing={8}>
                <Grid item xs={12}>
                    <Select
                        value={data.gruppe}
                        onChange={handleChange('gruppe')}
                        inputProps={{
                            id: 'gruppe',
                        }}
                        autoWidth
                        displayEmpty
                    >
                        <MenuItem value={"Partner"}>Produkte</MenuItem>
                        <MenuItem value={"Lieferant"}>Lieferant</MenuItem>
                        <MenuItem value={"Kunde"}>Kunde</MenuItem>
                    </Select>
                </Grid>
                <TextFieldHelper n={12} value={data.anrede} onChange={handleChange('anrede')} label="Anrede / Firmenname" />
                <TextFieldHelper n={6} value={data.vorname} onChange={handleChange('vorname')} label="Vorname" />
                <TextFieldHelper n={6} value={data.nachname} onChange={handleChange('nachname')} label="Nachname" />
                <TextFieldHelper n={2} value={data.land} onChange={handleChange('land', true)} label="Land" />
                <TextFieldHelper n={4} value={data.plz} onChange={handleChange('plz')} label="PLZ" />
                <TextFieldHelper n={6} value={data.ort} onChange={handleChange('ort')} label="Ort" />
                <TextFieldHelper n={12} value={data.adresse} onChange={handleChange('adresse')} label="Adresse / Straße" />
                <TextFieldHelper n={12} multiline rowsMax={4} value={data.notiz} onChange={handleChange('notiz')} label="Notiz" />
            </Grid>
        </div>
    )
}

class Kontakt extends React.Component {

    state = {
        kontakte: {},
        putLoading: {},
        tabs: 0,
        dialogOpen: false,
        newEntry: {

        },
        tableFilter: {

        }
    }

    componentDidMount() {
        document.title = "Kontakt"
        this.props.doLoad()
    }

    componentWillMount() {
        this.unsubscribe = store.subscribe(() => {
                var genericData = select(store.getState(), "kontakte")
                if(_.has(genericData, "putLoading") && this.state.putLoading !== genericData.putLoading) {
                    this.setState({
                        putLoading: genericData.putLoading
                    })
                }
                if(_.has(genericData, "dialogOpen") && this.state.dialogOpen !== genericData.dialogOpen) {
                    this.setState({
                        dialogOpen: genericData.dialogOpen
                    })
                }
            }
        )
    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    handleClickOpen = () => {
        this.setState({
            newEntry: {},
            dialogOpen: this.state.dialogOpen ? false : true
        });
    }

    postData = () => {
        this.props.doPost(this.state.newEntry)
        this.setState({
            newEntry: {}
        })
    }

    populate = (data) => {
        this.props.doLoad(data)
    }

    handleChange = (name, uppercase) => event => {
        if(uppercase) {
            event.target.value = event.target.value.toUpperCase()
        }
        this.state.newEntry[name] = event.target.value
        this.setState({
            newEntry: this.state.newEntry
        });
    }

    deleteAction = (id) => {
        if (window.confirm('Willst du den Eintrag wirklich löschen?')) {
            this.props.doDelete(id)
        }
    }

    gotoToDetail = (rowIndex, data) => {
        this.props.history.push("kontakte/"+this.props.kontakte.data[rowIndex].id)
    }

    render() {

        var {
            classes
        } = this.props

        var {
            dialogOpen, isLoading
        } = this.state

        if(isLoading) {
            return (
                <Loader />
            )
        }

        var items = []
        if(_.has(this.props, 'kontakte.data') && this.props.kontakte.data.length > 0) {
            this.props.kontakte.data.forEach((item) => {
                items.push([
                    item.gruppe ? item.gruppe : "-",
                    item.anrede ? item.anrede : "-",
                    item.plz ? item.plz : "-",
                    item.ort ? item.ort : "-",
                    item.adresse ? item.adresse : "-",
                    item.id
                ])
            })
        }

        return (
            <div>

                <Table
                    title="Kontakte"
                    key={"Kontakte"+items.length}
                    data={items}
                    count={this.props.kontakte.count}
                    columns={columns}
                    populate={this.populate}
                    onDelete={this.deleteAction}
                    rowClick={this.gotoToDetail}
                    options={{
                        selectableRows: false
                    }}
                />

                <Button variant="fab" className={classes.fab} onClick={this.handleClickOpen} color={"primary"}>
                    <AddIcon />
                </Button>
                <Dialog
                    title="Neuer Kontakt"
                    saveAction={this.postData}
                    closeAction={this.handleClickOpen}
                    open={dialogOpen}
                >
                    <KontaktDialog data={this.state.newEntry} handleChange={this.handleChange} />
                </Dialog>

            </div>
        )
    }

}

const mapStateToProps = state => ({
    kontakte: state.kontakte,
    //bankverbindungen: state.mitarbeiterBankverbindung,
    //beschaeftigung: state.mitarbeiterBeschaeftigung,
})

const mapDispatchToProps = (dispatch, ownProps) => ({

    doLoad: (filter) => dispatch(doLoad("kontakte", "api/generic/kontakt/list", filter)),
    doPost: (data) => dispatch(doPost("kontakte", "api/generic/kontakt", data)),
    doDelete: (id) => dispatch(doDelete("kontakte", "api/generic/kontakt/"+id, id)),
    //doPut: (id, data) => dispatch(doPut("MITARBEITER", "api/generic/mitarbeiter/"+id, data)),

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(Kontakt));



// WEBPACK FOOTER //
// ./src/Routes/Kontakt/index.js